import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useRef, useState, useEffect } from "@discovery/common-dplus/lib/hooks";
import { SonicImage, } from "@discovery/components-luna/lib/components/atoms/image";
import { Icon, Icons } from "../../../../../components/atoms/icon";
import { PlaceholderImage } from "../../../../../components/atoms/placeholder-image";
import { Link } from "../../../../../components/atoms/link";
import { HeaderVariants, Tags, Typography, } from "../../../../../components/atoms/typography";
import { Card as BaseCard } from "../base";
import { ProgressBar } from "../../../../atoms/progress-bar";
import * as styles from "./styles.css";
const IMAGE_SIZES = {
    default: [100, "vw"],
    maxWidthMediaQueries: [
        [699, "px", 120, "px"],
        [1023, "px", 140, "px"],
        [1439, "px", 180, "px"],
    ],
};
export const SecondaryCardMobile = ({ isFeaturedSecondaryCard, selectedId, id, hasRoute, image, route, vType, durationM, linkhref, viewingHistoryM, description, name, isSearchPage, showName, }) => {
    const ref = useRef(null);
    const [isIntersecting, setIntersecting] = useState(false);
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));
    useEffect(() => {
        const refvalue = ref && ref.current;
        if (refvalue)
            observer.observe(refvalue);
        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return !isFeaturedSecondaryCard ? (React.createElement("div", { className: cn(styles.secondaryCardContainer, {
            [styles.secondaryCardSelectedContainer]: id === selectedId && id !== undefined,
        }) },
        React.createElement(Link, { href: hasRoute ? route + `?type=${vType}` : "" },
            React.createElement("div", { className: styles.secondaryCardImage, ref: ref },
                React.createElement(PlaceholderImage, null),
                isIntersecting && (React.createElement(SonicImage, { image: image, imageSizes: IMAGE_SIZES, extraImageWidths: [340, 400], className: styles.secondaryImage, fallbackImageSize: { width: 260 }, alt: "image" })),
                React.createElement(Icon, { type: Icons.PlayButton, className: styles.playIconEpisode, color: "black" }),
                React.createElement("div", { className: styles.durationContainer },
                    React.createElement(BaseCard.Duration, { durationM: durationM })),
                React.createElement(ProgressBar, { className: styles.progressIndicator, durationM: durationM, viewingHistoryM: viewingHistoryM }))),
        React.createElement(Link, { href: hasRoute ? linkhref : "" },
            React.createElement("div", { className: styles.description },
                React.createElement(Typography, { classNameM: M.of(styles.descriptionHead), variant: HeaderVariants.subHeadOne, tag: Tags.span },
                    React.createElement(React.Fragment, null, name)),
                React.createElement(Typography, { classNameM: M.of(styles.descriptionContent), variant: HeaderVariants.subHeadTwo, tag: Tags.p },
                    React.createElement(React.Fragment, null, isSearchPage ? showName : description)))))) : (React.createElement(React.Fragment, null));
};

